// Login.js

import React, { useState } from 'react';
import {
  Box,
  Button,
  CircularProgress,
  Container,
  TextField,
  Typography,
  Paper,
  Alert,
} from '@mui/material';
import axios from 'axios';

export default function LoginForm() {
  const [name, setName] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [token, setToken] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setToken('');

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}admin/login`, { name, password });
      setToken(response.data.access_token);

      // Armazenar o token (ajuste conforme sua estratégia de autenticação)
      localStorage.setItem('token', response.data.access_token);
      localStorage.setItem('user', JSON.stringify(response.data.user));

      setName('');
      setPassword('');
      setError('');

      setTimeout(() => {
        window.location.reload();
      }, 3000);

    } catch (err) {
      if (err.response?.status === 401) {
        setError('Usuário ou senha inválidos');
      } else {
        setError('Erro ao tentar fazer login. Tente novamente.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="xs" sx={{ mt: 10 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography variant="h5" component="h1" align="center" gutterBottom>
          Elo - Login
        </Typography>

        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}

        <Box component="form" onSubmit={handleSubmit} noValidate>
          <TextField
            label="Usuário"
            fullWidth
            margin="normal"
            required
            autoFocus
            value={name}
            onChange={(e) => setName(e.target.value)}
            autoComplete="username"
            inputProps={{ 'aria-label': 'Usuário' }}
          />

          <TextField
            label="Senha"
            type="password"
            fullWidth
            margin="normal"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
            inputProps={{ 'aria-label': 'Senha' }}
          />

          <Button
            type="submit"
            fullWidth
            variant="contained"
            disabled={loading}
            sx={{ mt: 2, py: 1.5 }}
          >
            {loading ? <CircularProgress size={24} /> : 'Entrar'}
          </Button>
        </Box>
      </Paper>

      {token && (
        <Alert severity="success" sx={{ mt: 2 }}>
          Login bem-sucedido! Redirecionando...
        </Alert>
      )}
    </Container>
  );
}
